import React, { Fragment } from 'react'
import { Grid, Card, Image, Icon } from 'semantic-ui-react'
import { MainContext } from './State'

const Possession = () => {
  return (
    <MainContext.Consumer>
      {({ onChange, possession, gameData: { id, team1, team2 } }) => (
        <Fragment>
          <Grid.Row color="grey">
            <h2>Possession</h2>
          </Grid.Row>
          <Grid.Row columns="equal" color="grey" divided>
            <Grid.Column>
              <Card
                fluid
                onClick={() =>
                  onChange({
                    target: {
                      name: 'possession',
                      value: 0
                    }
                  })
                }
              >
                <Image centered src={team1.logo} size="small" />
                <Card.Content textAlign="center">
                  <h3>{team1.abbreviated}</h3>
                  {possession === 0 && (
                    <Icon name="check" size="large" color="green" />
                  )}
                </Card.Content>
              </Card>
            </Grid.Column>
            <Grid.Column>
              <Card
                fluid
                onClick={() =>
                  onChange({
                    target: {
                      name: 'possession',
                      value: 1
                    }
                  })
                }
              >
                <Image centered src={team2.logo} size="small" />
                <Card.Content textAlign="center">
                  <h3>{team2.abbreviated}</h3>
                  {possession === 1 && (
                    <Icon name="check" size="large" color="green" />
                  )}
                </Card.Content>
              </Card>
            </Grid.Column>
          </Grid.Row>
        </Fragment>
      )}
    </MainContext.Consumer>
  )
}

export default Possession



// WEBPACK FOOTER //
// ./src/components/Controller/Possession.jsx